module.exports = __webpack_public_path__ + "src/assets/img/gmap-icon.00ff7ef5.png";